var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLeftButtonArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 36 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7.4 15.1 1.4-1.4-4-3.9-.9-.6.1-.3 1.1.1h30.8V7H5.1L4 7.2l-.1-.3.9-.6 3.9-3.9L7.4 1 1 7.4v1.4z",
  className: "icon-left-button-arrow_svg__st0"
})));
export default SvgIconLeftButtonArrow;